export const selectLogState = (state) => state.log;
export const selectLogFilters = (state) => state.log.filters;
